import React from "react"
import { Card, CardBody, Input, Table } from "reactstrap"

import DimensionInput from "components/Common/DimensionInput"

export default function Dimensions(props) {
  const { config } = props

  const onTextInputChange = params => {
    const { name: _key, val, obj, idx } = params
    let _obj = {}

    const dimensionExist =
      config.payload.jacket.dimensions &&
      config.payload.jacket.dimensions[idx] !== undefined

    if (dimensionExist) {
      _obj = {
        ...config.payload.jacket.dimensions[idx],
        formId: obj.formId,
        sequence: obj.sequence,
      }

      switch (_key) {
        case "gaugeDimensions": {
          _obj.gaugeDimensions = val
          _obj.lawToGoUp =
            parseFloat(val || 0) + parseFloat(_obj.correctionValue || 0)
          break
        }
        case "correctionValue": {
          _obj.lawToGoUp =
            parseFloat(_obj.gaugeDimensions || 0) + parseFloat(val || 0)
          _obj.correctionValue = val
          break
        }
        case "lawToGoUp": {
          _obj.correctionValue =
            parseFloat(val || 0) - _obj.gaugeDimensions || 0

          _obj.lawToGoUp = val
          break
        }
      }
    }

    config.handleJacketInput(_obj, "dimensions", idx)
  }

  return (
    <Card>
      <CardBody>
        <Table bordered>
          <tbody>
            <tr>
              <td
                style={{
                  padding: 5,
                  minWidth: 105,
                  verticalAlign: "middle",
                }}
              >
                <p className="mb-0">サイズ</p>
              </td>
              <td colSpan={3} style={{ position: "relative" }}>
                <Input
                  onBlur={e => config.onTgBlur(e, ["上着", "jacket"])}
                  onChange={e => config.handleJacketInput(e, "tg")}
                  style={{ height: 33, paddingLeft: 30 }}
                  type="text"
                  value={config.payload?.jacket?.tg}
                />
                <span
                  style={{
                    position: "absolute",
                    left: 16,
                    top: 18,
                    opacity: 0.5,
                  }}
                >
                  Tg
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ padding: 5, verticalAlign: "middle" }}>
                <p className="mb-0">寸法</p>
              </td>
              <td style={{ padding: 5 }}>
                <p className="mb-0 text-center">ゲージ寸法</p>
              </td>
              <td style={{ padding: 5 }}>
                <p className="mb-0 text-center">補正値</p>
              </td>
              <td style={{ padding: 5 }}>
                <p className="mb-0 text-center">上り寸法</p>
              </td>
            </tr>
            {props?.config?.orderSheets?.jacket?.dimensions &&
              props.config.orderSheets.jacket.dimensions
                .filter(dim => dim.item)
                .map((obj, idx) => {
                  const payloadDim = config.payload.jacket.dimensions
                  return (
                    <tr key={idx}>
                      <td style={{ padding: 5 }}>
                        <p className="mb-0">{obj.item}</p>
                      </td>
                      {["gaugeDimensions", "correctionValue", "lawToGoUp"].map(
                        t => (
                          <td key={t} style={{ padding: 5 }}>
                            <DimensionInput
                              name={t}
                              onValueChange={(val, name) =>
                                onTextInputChange({ val, name, obj, idx })
                              }
                              value={payloadDim[idx]?.[t]}
                            />
                          </td>
                        )
                      )}
                    </tr>
                  )
                })}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  )
}
